module.exports = __webpack_public_path__ + "img/qundao.bd3744e8.png";